export default {
  line: "Line",
  language: "Language",
  common: [
    "Service",
    "Cancel Suspension",
    "Robot",
    "Automatic video",
    "Start",
    "Number of videos remaining today",
    "Automatic number",
    "Only available to premium members, please upgrade",
    "Please set the number of automatic videos"
  ],
  upload: [
    "Uploading...",
    "Wrong format",
    "Uploaded successfully",
    "Upload failed"
  ],
  appMsg: [
    "Ready to download updates...",
    "The download is complete, whether to install the update package",
    "Download update failed",
    "{num}% downloaded",
    "Updating...",
    "The update is successful and will restart soon",
    "Update failed",
    "Press again to exit the application"
  ],
  vanPull: [
    "No more data",
    "No data"
  ],
  login: {
    text: [
      "Remember Password",
      "Logging...",
      "Log in now",
      "Forgot password",
      "Mobile Login",
      "Email Login"
    ],
    placeholder: [
      "Please enter phone number",
      "Please enter login password",
      "Please enter email address"
    ],
    i18n: [
      "No {title} account?",
      "Register"
    ]
  },
  register: {
    text: [
      "Welcome to register",
      "SMS code sending...",
      "Get SMS code",
      "Registering...",
      "Register now",
      "Have an account,download now",
      "Mobile Register",
      "Email Register",
      "Get Verification Code",
      "SMS Verification Code",
      "Email Verification Code",
      "Resend Verification Code"
    ],
    placeholder: [
      "Please enter your phone number",
      "Please enter SMS verification code",
      "Please enter the login password",
      "Please confirm your password",
      "Please enter the invitation code",
      "Two passwords are different",
      "Please enter the verification code"
    ],
    i18n: [
      "Have an account?",
      "Login"
    ],
    tips: "Register Tutorial"
  },
  footer: [
    "Home",
    "Video",
    "Chat",
    "Chat",
    "My",
    "Profit",
    "Crowdfunding",
    "Dynamic",
    "Activity"
  ],
  home: {
    broadcast: "Congratulations to member {member} for recommending a {grade} to get {currency}{reward} promotion rewards!",
    menu: [
      "VIP area",
      "Video tutorial",
      "Promotion rewards",
      "Cooperative media",
      "Company strength",
      "Account insurance"
    ],
    taskHall: {
      title: [
        "Video hall",
        "Business Hall"
      ]
    },
    memberList: {
      title: "Membership List",
      data: [
        "Congratulations {member}",
        "Watch {num} videos today and earn {currency}{profit}!"
      ]
    },
    businessList: {
      title: "Merchant List",
      data: [
        "{member}",
        "Release {num} single video today"
      ]
    },
    noticeTitle: "The latest announcement",
    msg: "The video is not open",
    video: "No video tutorial",
    title: ["Company Profile","Membership Level"]
  },
  postTask: {
    navBar: {
      title: "Release mission",
      right: "Release rules"
    },
    field: [{
        label: "Video classification",
      },
      {
        label: "Video title",
        placeholder: "Please enter a video title",
        error: "Video title cannot be empty"
      },
      {
        label: "Video Brief",
        placeholder: "Please enter a video description"
      },
      {
        label: "Video unit price",
        placeholder: "Please enter the video unit price",
        error: "Video unit price cannot be empty"
      },
      {
        label: "Number received",
        placeholder: "Please enter the number",
        error: "The quantity cannot be empty"
      },
      {
        label: "Number of receipts",
        placeholder: "Please enter the number of receipts",
        right: "Times/person",
        error: "The number of receipts cannot be empty"
      },
      {
        label: "Total video price",
        error: "The total video price is not calculated"
      },
      {
        label: "Link information",
        placeholder: "Please enter the link address",
        error: "Link information cannot be empty"
      },
      {
        label: "Video level",
      },
      {
        label: "Deadline",
        placeholder: "Click to select date",
        error: "Deadline cannot be empty"
      },
      {
        label: "Conditions of completion",
        error: "Please select a completion condition"
      },
      {
        label: "Upload requirements",
        placeholder: "Please enter upload request",
      },
      { 
        label: "Sample audit",
      },
      {
        label: "Steps",
        placeholder: "Easy to understand steps help to complete!",
        error: "Operation step cannot be empty",
        img: "Step diagram is not perfect"
      },
    ],
    button: "Submit",
    step: {
      title: "Steps",
      left: "Cancel",
      right: "Completed",
      placeholder: "Please enter a step description",
      button: [
        "Delete",
        "Add"
      ]
    },
    tips: [
      "Platform handling fee {pump}{br}This release will require payment of about {price},Please ensure that the balance of the account is sufficient {a}{br}Tip: This platform prohibits the release of pornography, gambling, drugs and all other legal prohibited content, such as deduction points, blocked account.",
      "To recharge",
      "Keep at least one step",
      "Add up to ten steps"
    ]
  },
  vip: {
    user: {
      title: [
        "Current Level",
        "Visitors"
      ],
      label: "Daily Videos",
      value: [
        "Validity Period",
        "Permanent Validity",
        "Please Login First",
        " days",
        "Expire Date"
      ],
    },
    list: {
      label: "Daily videos <b>{number}</b> times",
      button: [
        "Activate Now",
        "Immediate Renewal"
      ],
      text: [
        "Daily Profit",
        "Monthly Income",
        "Recommendation Reward: Everyone",
        "Free",
        "Per order"
      ]
    },
    dialog: [
      "Are you sure to spend {currency} {amount} to become {name}?",
      "You are currently {currname} and cannot be {name}",
      "Are you sure to spend {currency} {amount} to renew {name}?"
    ],
    more: "See More",
    top: [
      "Required for upgrade",
      "Purchase rebate",
      ["Level 1", "Level 2", "Level 3"],
      ["Price","Details"],
      "Expired"
    ]
  },
  user: {
    title: [
      "My Video",
      "Personal Records"
    ],
    default: [
      "My",
      "Account",
      "Invitation code",
      "Exit login",
      "Balance",
      "Gold",
      "My wallet",
      "Seal",
      "Restriction",
      "Good",
      "Excellent",
      "My superior"
    ],
    grid: [
      "Balance",
      "Yesterday's Earnings",
      "Today's Earnings",
      "This Week's Earnings",
      "This Month's Earnings",
      "Last Month's Earnings",
      "Total Earnings",
      "Today's Watch(PCS)",
      "Today's Remaining Videos(PCS)",
      "Today's Commission",
      "Today's Rebate",
      ["Today","Yesterday","Week","Month"],
      ["View Earnings","Promote Earnings","Crowdfunding Earnings","Invest Earnings","Invest Rebate"],
      ["This Week's Register", "This Week's Valid Register", "Total Salary"],
      ["Today","Yesterday","Three days"]
    ],
    menu: [
      "Watch Records",
      "Audit Video",
      "Release Manage",
      "Personal Information",
      "Account Binding",
      "Daily Statement",
      "Accounting Records",
      "Invite Friends",
      "Team Reports",
      "Helpbook",
      "Credit Centres",
      "Download APP",
      "My Invest"
    ]
  },
  userInfo: {
    default: [
      "Personal Information",
      "Default Avatar",
      "Mobile Number",
      "Bank Card",
      "Alipay",
      "Real Name Verified",
      "Login Password",
      "Transaction Password",
      "Click Settings",
      "Change Default Avatar",
      "Change Login Password",
      "Change Transaction Password",
      "Submit",
      "Empty the cache",
      "USDT Wallet",
      "Push Switch",
      "My Address"
    ],
    label: [
      "Current Password",
      "New Login Password",
      "Confirm Password",
      "Current Password",
      "New Transaction Password",
      "Confirm Password",
      "Forgot Transaction Password",
      "SMS Code",
      "Verify Code"
    ],
    placeholder: [
      "Please enter the current password",
      "Please enter the new login password",
      "Please confirm the new login password",
      "Please enter the current transaction password",
      "Please enter the new transaction password",
      "Please confirm the new transaction password"
    ]
  },
  userSet: {
    default: [
      "Real Name Verified",
      "Detailed Information",
      "Bind Alipay",
      "Submit",
      "Bind USDT Wallet",
      "Change wallet address",
      "E-mail verification",
      "Sample graph",
      ["Reviewing", "Audit Successful", "Audit Failure"]
    ],
    label: [
      "Real name",
      "QQ",
      "Alipay account",
      "Alipay Name",
      "Wallet Type",
      "Wallet Address",
      "Address Info",
      "Contact",
      "Telephone",
      "Wallet Screenshot"
    ],
    placeholder: [
      "Please enter a real name(My name is used for cash withdrawal)",
      "Enter QQ number",
      "Please enter Alipay account",
      "Please enter Alipay name",
      "Please select a wallet type",
      "Please enter wallet address",
      "Please enter detailed address",
      "Please verify your real name first",
      "Please bind your email address first"
    ],
    tips: "Reminder: The bound bank card cannot be modified, it is used for your withdrawal"
  },
  bindAccount: {
    default: [
      "Bind Account",
      "View the tutorial",
      "Submit"
    ],
    tabs: [
      "Account",
      "Account",
      "Account"
    ],
    label: [
      "Instructions",
      "Add screenshot",
      "Account"
    ],
    placeholder: "Please enter your {account} account"
  },
  bankCard: {
    default: [
      "Bind bank card",
      "Authenticate now",
      "Submitting ...",
      "Add it now",
      "Add"
    ],
    tips: [
      "Please add your bank card after real name authentication",
      "The account opening name of your bound bank card must be the same as your verified real name, otherwise you will not be able to withdraw successfully."
    ],
    label: [
      "Name",
      "Bank name",
      "Bank account",
      "IFSC code"
    ],
    placeholder: [
      "Please select bank name",
      "Please enter the Bank account",
      "Please enter the IFSC code"
    ]
  },
  wallet: {
    default: [
      "My wallet",
      "Recharge",
      "Withdrawal",
      "Recharge record",
      "Withdrawal record",
      "R",
      "W",
      "Alipay"
    ],
    label: [
      "Withdrawal Method",
      "Withdrawal Amount",
      "Transaction Password",
      "Submit",
      "Phone Number",
      "Email",
      "IFSC"
    ],
    placeholder: [
      "Select withdrawal method",
      "Please input the withdrawal amount",
      "Please input transaction password",
      "Please select the withdrawal method",
      "Please enter the payee's mobile phone number",
      "Please enter the payee's email address",
      "Please enter the payee IFSC"
    ],
    msg: [
      "You haven't set the transaction password yet, please set it first",
      "You haven't tied a bank card, please bind it first"
    ]
  },
  recharge: {
    default: [
      "Recharge",
      "Recharge details",
      "Recharge record",
      "Available balance {money}, please choose recharge method",
      "Single minimum amount is {currency} {min}, maximum {currency} {max}, handling fee {fee}%",
      "Submitting...",
      "Recharge now",
      "Return",
      "Loading..."
    ],
    label: [
      "Recharge amount",
      "Recharge channel",
      "Name of transfer",
      "Payer's Name",
      "Payer's Mobile Phone",
      "Payer UPI Account",
      "Payer's Email"
    ],
    placeholder: [
      "Please enter the recharge amount",
      "Please select recharge channel",
      "Please enter the name of the transfer",
      "Single minimum amount is {currency} {min}",
      "Single maximum amount is {currency} {max}",
      "Please enter the name of the payer",
      "Please enter the payer's mobile phone number, prefix the number with the international area code, such as +86",
      "Please enter the UPI account of the payer",
      "Please enter the payer's email address",
    ],
    info: [
      "Recharge amount",
      "Order number",
      "Bank",
      "Account no",
      "Name",
      "Copy",
      "{type} Transfer",
      "Transfer screenshot",
      "Submit",
      "IFSC Code",
      "UPI",
      "Processing instructions",
      "Wallet Address",
      "Receipt QR Code"
    ],
    tips: [
      "Please select the following method to transfer the matching amount to avoid delay in the financial check.<br>After the transfer, please upload the transfer screenshot as a verification certificate",
      "No need to add friends, scan the QR code to transfer money to me",
      "Please complete the transfer according to the information below",
      "Hint: After successful payment, please contact online service to provide your member account number, recharge amount, order number, depositor account number, recharge time, convenient for financial department to add funds for you in time.",
      "Note: please submit one payment for each transfer",
      "After the transfer, please upload the transfer screenshot as a verification certificate",
      "Please choose the following method to transfer the matching amount",
      "Please upload a screenshot of the transfer",
      "Exchange Rate:{price}×{rate}={currency}<b>{money}</b>,(1USDT={currency}{rate})",
      "recharge rebate"
    ]
  },
  task: {
    default: [
      "Watch Records",
      "Video requirements",
      "Create",
      "Audit",
      "Open the link",
      "Copy the link",
      "Unit Price",
      "Submit",
      "Waiver",
      "Watch Time"
    ],
    tabs: [
      "Doing",
      "Audit",
      "Completed",
      "Failed",
      "Malice",
      "Abandoned"
    ],
    msg: "Please upload the finished picture",
    info: [
      "Video details",
      "Video title",
      "Video benefits",
      "Video description",
      "Upload requirements",
      "Submit sample",
      "The user did not submit the sample",
      "Audit notes",
      "Date of audit",
      "Demand side",
      "Release",
      "Copy",
      "Jump",
      "Video steps",
      "Step {index}",
      "Audit sample",
      "No audit sample",
      "Data loading...",
      "Give up the video",
      "Start Watching",
      "Publish content"
    ],
    index: [
      "Current status",
      "Your current rating is <i style=\"color:#1989fa\">{currVip}</i><br>can only claim the current <i style=\"color:#1989fa\">{currVip}</i> level video<br>do you want to join <i style=\"color:#dd6161\">{vip}</i> level",
      "Join now",
      "Please select video category"
    ],
    list: [
      "Video list",
      "Demand side",
      "Remaining",
      "Request",
      "Receiving"
    ],
    show: [
      "Video details",
      "Man has earned it",
      "Remaining {num} places",
      "Audit within 48 hours",
      "Video description",
      "Demand side",
      "Audit standards",
      "Copy",
      "Jump",
      "Video steps",
      "Step {index}",
      "Audit sample",
      "No audit sample",
      "Data loading...",
      "Submitting...",
      "Collect video",
      "Log in now",
      "Publish content"
    ]
  },
  audit: {
    default: [
      "Audit video",
      "Receive users",
      "Pick up date",
      "Update date",
      "Audit",
    ],
    tabs: [
      "Doing",
      "Audit",
      "Completed",
      "Failed"
    ],
    info: [
      "Audit details",
      "Video title",
      "Video amount",
      "Person completed",
      "Remaining {num} places",
      "Video description",
      "Link information",
      "Audit sample",
      "Collect users",
      "Receive",
      "Completion status",
      "Submit sample",
      "The user did not submit the sample",
      "Update date",
      "Data loading...",
      "Malicious",
      "Retrial",
      "Failure",
      "Success",
      "Audit video",
      "Audit instructions",
      "Please enter audit description",
      "If the submitted video is unqualified, it needs to be re submitted for review",
      "Congratulations on the completion of the video",
      "The submitted video page screenshot error, the video failed",
      "Malicious submission video, video failed"
    ]
  },
  postRecord: [
    "Release management",
    "Release",
    "Total",
    "Completed",
    "Deadline",
    "Audit",
    "Rescission",
    "Editors"
  ],
  dayReport: [
    "Daily statement",
    "Total revenue",
    "My mission",
    "My mission benefits",
    "Videos completed by subordinates",
    "Subordinate video benefits",
    "PCS",
    "Last 30 days",
    "Quantity",
    "Video",
    "Subordinate",
    "Consumption",
    "Date"
  ],
  fundRecord: {
    default: [
      "Expense Records",
      "Recharge Record",
      "Revenue Records",
      "R",
      "R",
      "E"
    ],
    tabs: [
      "Revenue",
      "Expense",
      "Recharge"
    ]
  },
  promote: [
    ["Every {num} valid users invited","Earn","Cash"],
    "Can be withdrawn directly",
    "Every {num} valid users invited",
    ["Daily Rewards", "Everyone can claim every day"],
    ["Valid users","Invite {num} paid users per day"],
    ["Invite","Receive","Invite Now"],
    "Team Employee Award",
    ["Star Agent","Bonus","Salary"],
    ["Person","Request","Invited"],
    "Commission Introduction",
    ["Share","Get"],
    ["Share on social platforms","Share"],
    ["Recharge","Recharge by yourself","Recharge"],
    ["Mining","Buy mining","Buy"],
    ["Financial","Investment and financial management","Invest"],
    ["Share with friends now","Invitation code"],
    ["Copy link","Copy Invitation Code","QR Code","Share Poster"],
    "Save Picture",
    "Friends Upgrade VIP Rewards",
    "Details"
  ],
  teamReport: {
    default: [
      "Search",
      "Team Balance",
      "Team Earnings",
      "Team Recharge",
      "Team Withdraw",
      "First Charge",
      "First Push",
      "Team Size",
      "New Team",
      "PCS",
      "Me",
      "User",
      "Recharge",
      "Withdraw",
      "Rebate",
      "Video",
      "Select Date",
      "No Data",
      "Recharge Amount",
      "Recharge Number",
      "Promote Earnings",
      "Total VIP",
      "Efficient Member"
    ],
    tabs: [
      "Team Reports",
      "My Team"
    ],
    team: [
      "Level 1",
      "Level 2",
      "Level 3"
    ]
  },
  help: [
    "Helpbook",
    "Not available"
  ],
  credit: [
    "Credit centres",
    "Credit note",
    "Credit records",
    "<p>1.Credit points are evaluated once a week</p><p>2.Initial user credit score:<b>60</b></p><p>3.If it is detected that the user does a video to upload a false image, it will be deducted one day:<b>1</b>Upper limit of points deduction:<b>7</b>integral</p><p>4.If the user does not detect the use of false images to increase<b>1</b>integral</p><p>5.Credit score below<b>50</b>Cash withdrawal will be restricted</p><p>6.Credit score below<b>30</b>Halve the number of tapping videos</p><p>7.Credit score less than or equal to<b>0</b>score Will be banned</p>",
    "My credit",
    "There is no credit record for the time being"
  ],
  appDown: [
    "App Download",
    "Scan QR code to download app",
    "Save QR code",
    "QR code saved successfully",
    "Failed to save QR code, please try a few more times or save the screenshot",
    "Copy",
    "Android Download",
    "IOS Download",
    "If the IOS version cannot be downloaded normally, please uninstall the original version and download and install it again. Not uninstalling will affect the use"
  ],
  dialog: [
    "Tips",
    "Confirm",
    "Submitting...",
    "Copy succeeded",
    "IOS system version is low and not supported",
    "Registering...",
    "Data loading...",
    "Not yet open, so stay tuned",
    "Save image successfully",
    "Failed to save the image<br>If unsuccessful, please try several times or take a screenshot to save",
    "The browser does not support, please take a screenshot",
    "Investment in progress",
    "There are currently no payment plans"
  ],
  lineList: [
    "Line selection",
    "Current line",
    "Line"
  ],
  serviceCenter: [
    "Customer service",
    "Hi, exclusive customer service",
    "Glad to serve you.",
    "Self service",
    "Online customer service",
    "Recharge customer service",
    "Line customer service",
    "Connect",
    "Help Manual",
    "Website Announcement"
  ],
  theme: {
    title: "Switch theme",
    black: "Black Theme",
    white: "White theme",
    green: "Dark Green Theme"
  },
  Finance: [
    ["Daily Dividend","Gift Equity","Gift Option","Additional Subsidy","Times"],
    "Buy Now",
    "Financial Detail",
    "Order Price",
    ["Percent","Days"],
    "Order Now",
    ["Account Balance", "Unit Price", "Daily Dividend", "Project Cycle", "Days", "Number Of Buy", "Maximum number of buy", "Expected earnings"],
    "Submit",
    "My Finances",
    ["Withdraw Interest","End","Detail"],
    ["Are you sure to withdraw the interest, the interest will be recalculated after withdrawal", "Are you sure to end this financial"],
    "Order Detail",
    ["Total Amount","Order Status","Buy Date"]
  ],
  Video: [
    ["Visitors","Upgrade to enjoy more benefits"],
    "Upgrade",
    ["Today's Income", "Every order", "To Withdraw"],
    ["Number of videos watched today","Remaining times"],
    "Start Watching",
    "Login To Watch",
    "View In Full Screen",
    "Close",
    ["recommend you to download","Free Download"],
    "Current Online User",
    "All Finish",
    "Please bind your phone number first",
    "Please bind your email address first"
  ],
  Disclaimer: [
    ["I have read and agree","Disclaimer"],
    ["Login Agreement","Disagree","Agree"]
  ],
  Withdraw: [
    "Available balance {money}, please select a withdrawal account",
    "Withdrawal Account",
    "Please select a withdrawal account",
    "Withdrawal Amount",
    "Please enter the withdrawal amount",
    "Wallet Address",
    "Please enter wallet address",
    "Transaction Password",
    "Please enter the transaction password",
    "Withdraw Now",
    "Exchange rate: {price}÷{rate}=<b>{money}</b>USDT,(1USDT={currency}{rate})",
    "Select Withdrawal Account",
    ["Add Bank Account","Bind USDT Wallet"],
    "Actually Received",
    "Phone",
    "Please enter phone number",
    "Email",
    "please input your email",
    "UPI",
    "Please enter UPI",
    "Withdrawing USDT-TRC20 only supports the use of TRUST wallet",
    "Download TRUST Wallet"
  ],
  Partner: [
    "Crowdfunding Level",
    "Crowdfunding",
    ["Initiate Crowdfunding","Join Crowdfunding","My Crowdfunding"],
    ["Crowdfunding Level","Please select a crowdfunding level"],
    ["Crowdfunding Copies","Please select the crowdfunding copies"],
    ["Buy","Please enter the number of copies purchased"],
    "Amount Per Share",
    "Crowdfunding Now",
    ["In Progress","Completed"],
    ["Initiator", "Crowdfunding Level", "Crowdfunding Copies", "Amount Per Copies", "Purchased", "Servings", "Add To", "Profit", "Join", "Crowdfunding Date"],
    "Crowdfunding Rules",
    ["Crowdfunding Name","Please enter the crowdfunding name"]
  ],
  Share: [
    "Daily Bonus",
    ["Task List", "Registered users who cheat will be banned", "Share"],
    ["Task Steps","Upload {num} times every day"],
    ["Withdrawal success image", "withdrawal pictures successfully shared to the official group", "Users who submit spam content will be blocked", " After approval, the reward will be issued to your account"],
    ["Please select a screenshot to upload","Please enter your {name} link address","Example Images"],
    "Submit",
    "Share",
    "Share Today's Earnings",
    "Step Instructions",
    "Share Copywriting",
    "Copy",
    "Submit Screenshots Or Links",
    "Cancel",
    "Rewards available",
    "Bonus"
  ],
  Community: [
    "Dynamic",
    ["Latest","Withdrawal","Buy","Commission","Income"],
    ["Price","Revenue Per View","Videos Per Day"],
    "Buy Same VIP"
  ],
  Register: [
    "Please enter the email",
    ["Please enter the email verification code","Get the email code","Email verification code"]
  ],
  UserInfo: [
    ["Email","Click to bind"],
    ["Bind Phone", "Bind Email"],
    ["Phone Number","Please enter phone number"],
    ["Email","Please enter the email"],
    "Please bind your phone number before withdraw",
    "Please bind your email before withdraw",
    ["Telegram Certification","Tutorial"]
  ],
  Bet: [
    "Distance {no} lottery draw",
    "Waiting Draw",
    "Account Balance",
    "Issue",
    "Issue",
    "Bet Content",
    "Bets",
    "Amount",
    "State",
    "No Record",
    "Put Away",
    "Time",
    "Issue",
    "Winning Numbers",
    "Sum",
    "Bet",
    "Congratulations <em id='win_name'>{name}</em> for betting in <i id='win_lottery'>{lottery}</i> and winning <em id='win_money'>{currency}{price }</em>",
    "My<br>Bets",
    "Lottery<br>Record",
    "Play",
    "How to play",
    "Connecting Rooms...",
    "Waiting Draw",
    "Not Winning",
    "Winning {price}",
    "Deleted",
    "Cancelled",
    "Stopped",
    "Go Water",
    "Send failed, click the message to resend",
    "The betting room does not exist",
    "Whether to follow",
    "Follow",
    "Your browser does not support the WebSocket protocol",
    "Chat communication failed, trying to reconnect",
    "Tips,",
    "seconds, clear the screen",
    "Your browser does not support",
    "Bet Type",
    "You are not login, please login first",
    "Can only send pictures",
    "The account balance is less than {balance}, you cannot enter the room, please recharge",
    "Trend",
    "Official Web",
    "Profit",
    ["Bet","Winner","Rebate","Profit"],
    ["Today","Yesterday","Week","Month","Total"]
  ],
  BetView: [
    "Max Odds",
    "Bonus",
    "Quick Amount",
    "Bets",
    "Enter Amount",
    "Cancel",
    "Chase",
    "Bet Now",
    "Loading...",
    "Bet Content",
    "Odds",
    "Please enter the bet amount",
    "The current issue is not open",
    "Waiting for the draw, can't bet",
    "This issue has been closed, please bet on the next issue",
    "Please select bet content",
    "Follow Bet",
    "Issue",
    "Issue",
    "How to play",
    "Bet Content",
    "Bet Amount",
    "Follow",
    "Only available to VIP users"
  ],
  Coupon: [
    "Voucher",
    ["Pending Use", "Used", "Expired"],
    ["VOUCHER","Valid until ","VALUE"],
    "Transfer ",
    ["All","Please enter the recipient's account","Confirm","Cancel"]
  ],
  Trend: [
    "Trend",
    ["30 Issues", "50 Issues", "100 Issues"],
    ["Single Trend","Multiple Trend","Size Trend","Odd-Even Trend","Sum Value|Shape"],
    ["Hundreds", "Tens", "Ones", "Three Yards", "First Two", "Last Two", "Three Yards Sum"],
    ['Hundreds-Tens-Ones,3', 'Hundreds,2', 'Tens,2', 'Ones,2'],
    ['Hundreds-Tens-Ones,3', 'Sum Value', 'Shape,2'],
    ["Big","Small"],
    ["Even","Odd"],
    ["Big","Small","Sum","Even","Odd"],
    "Issue",
    ["Issues", "Appear Number", "Max Continuous Out", "Max Omission", "Average Omission"]
  ],
  BlindBox: [
    "Prize Record"
  ],
  Activity: [
    "Activity",
    ["All","Agent","Member","Strategic Cooperation","End"],
    "View Details"
  ],
  Invest: [
    "Financial project",
    "Guaranteed",
    "Daily Rate",
    "Annualized Interest Rate",
    "days",
    "Investment Term",
    "Total Interest Rate",
    "Starting Amount",
    "Total number of shares issued: {num}",
    "Project size: {currency} {project_scale}",
    "Invest",
    "Sold Out",
    "Project Progress",
    "Account Available Balance",
    "Project Available Amount",
    "Project Name",
    "Investment amount",
    "Interest Settlement Time",
    "Investment amount",
    "Minimum Investment",
    "Incremental",
    "Earnings Available",
    "Funding password",
    "Please enter your password, the default password is login",
    "Invest Now",
    "Please verify your real name first",
    "You haven't set the password, go set it"
  ],
  InvestOrder: [
    "shares",
    ["Dividends per share", "Project period", "Days", "Investment amount"],
    ["Project Name", "Investment Amount", "Status", "Action"],
    ["Transfer Out", "Details"], ["Project Name", "Investment Amount", "Status", "Action"], ["Transfer Out", "Details"]
  ],
  InvestDetail: [
    "Investment details",
    "Investment amount",
    "Expected benefits",
    "Investment Time",
    "Maturity time",
    "Benefit Method",
    "Period Number",
    "Principal Amount Receivable",
    "Interest Receivable",
    "Total Amount Receivable",
    "Time of Payment",
    "Paid",
    "Status",
    "Period {no}",
    "Contract",
    "Contract Details"
  ],
}